import React from 'react'
import { Container, Row, Col, Button } from 'react-bootstrap'
import girl from '../../assets/girl.png'
import { FaToggleOn, FaGoogle, FaLink } from 'react-icons/fa'

const Main = () => {
    return (
        <Container fluid>
            <div className="MainHeader">
                <Row>
                    <Col lg={5} sm={12} xs={12}>
                        <div className="MainLeftPanel">
                            <h1>Get your name out there!</h1>
                            <h3>
                                Need a CV to show your skills? We got your covered!
                            </h3>
                            <p>
                                Fill in a few forms and we'll cook up a daper looking website CV for you. Our tool helps thousands get their web profile up and running.
                            </p>
                            <div className="ButtonHome">
                                <Button variant="primary" onClick={() => { window.location = "/login" }} className="insideButton" size="lg">Let's get Going!</Button>
                            </div>
                        </div>

                    </Col>
                    <Col lg={7} sm={12} xs={12}>
                        <div className="clip-block MainRightPanel">
                            <svg class="clip-svg1" width="0" height="0">
                                <defs>
                                    <clipPath id="clip-wrap1" clipPathUnits="objectBoundingBox" >
                                        <polygon points="1 1, 1 0, 0.14 0, 0 1" />
                                    </clipPath>
                                </defs>
                            </svg>
                            <figure className="clip-wrap">
                                <svg class="clip-svg" width="0" height="0">
                                    <defs>
                                        <clipPath id="clip-shape" clipPathUnits="objectBoundingBox" >
                                            <polygon points="1 1, 1 0, 0.25 0, 0.11 1" />
                                        </clipPath>
                                    </defs>
                                </svg>
                                <img src={girl} className="clip-css" width="100%" />

                            </figure>
                        </div>
                    </Col>
                </Row>
            </div>
            <section className="WhyUS">
                <div className="headingSec">
                    <h1>Why Us?</h1>
                </div>
                <div className="innerSectionWhyUs">
                    <Row>
                        <Col lg={4} sm={12} xs={12}>
                            <div className="eachCONT">
                                <div className="top">
                                    <FaLink />
                                </div>
                                <div className="down">
                                    <h4>Custom URL</h4>
                                    <p>
                                        Customize your CV URL to give it an even more personal touch. Paste this URL on your socials to allow others to visit your profile.
                                    </p>
                                </div>
                            </div>
                        </Col>
                        <Col lg={4} sm={12} xs={12}>
                            <div className="eachCONT">
                                <div className="top">
                                    <FaToggleOn />
                                </div>
                                <div className="down">
                                    <h4>Dark Mode</h4>
                                    <p>
                                        Keep your profile easy on the eyes. With your dark mode option for no extra cost give your profile the look you feel suits your needs.
                                        </p>
                                </div>
                            </div>
                        </Col>
                        <Col lg={4} sm={12} xs={12}>
                            <div className="eachCONT">
                                <div className="top">
                                    <FaGoogle />
                                </div>
                                <div className="down">
                                    <h4>Google Integration</h4>
                                    <p>
                                        All you need for your Fresume account is a Google account which we use for authentication. No pesky emails and passwords to remember.
                                    </p>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </section>

            <section className="demo">
                <div className="demoHeading">
                    <h1>Have a look for yourself</h1>
                </div>
                <div className="innerDemo">
                    <Row>
                        <Col>
                            <div className="demoSection">
                                <div className="imgDemo"></div>
                                <div className="demoWriteup">
                                    <h3>Anubhav Singh</h3>
                                    <h6>Founder, Alphacode</h6>
                                    <div className="demoButtonProfile">
                                        <a href="https://fresume.netlify.app/anubhav" className="btn btn-lg btn-outline-primary demoInsideBtn" target="_blank" rel="noreferrer noopener">View Profile</a>

                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </section>
        </Container>

    )
}
export default Main;